import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import {createUploadLink} from 'apollo-upload-client'

export const loginRedirect = () => {
  const currentUrl = window.location.href;
  const redirectUrl = `${process.env.REACT_APP_LOGIN_URL}?${process.env.REACT_APP_LOGIN_REDIRECT_PARAM}=${currentUrl}`;
  window.location.href = redirectUrl;
};

export const logoutRedirect = () => {
  const redirectUrl = `${process.env.REACT_APP_LOGOUT_URL}`;
  window.location.href = redirectUrl;
};

const cache: InMemoryCache = new InMemoryCache();

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
  credentials: "include",
});

const uploadLink = createUploadLink({
  uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
  credentials: "include",
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (networkError) {
    if ("statusCode" in networkError && networkError.statusCode === 401) {
      loginRedirect();
    }
  }
});

//@ts-ignore
const link = ApolloLink.from([errorLink, uploadLink]);

export const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  cache,
  link,
});
